export function notifyRecordingChange(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('recording-saved'))
  }
}
